import {
  type MyuiEditableType,
  type MyuiTemplateContext,
} from '@myre/ui-primitive-components';

import { FormControl, FormGroup } from '@angular/forms';

export enum MyuiPeriodPickerKey {
  To = 'to',
  From = 'from',
  Type = 'type',
  Range = 'range',
  Option = 'option',
}

export interface MyuiPeriodPickerRange {
  [MyuiPeriodPickerKey.To]: Date;
  [MyuiPeriodPickerKey.From]: Date;
}

export interface MyuiPeriodPickerSignature {
  [MyuiPeriodPickerKey.Type]: FormControl<string | null>;
  [MyuiPeriodPickerKey.Option]: FormControl<string | null>;
  [MyuiPeriodPickerKey.Range]: FormGroup<{
    [MyuiPeriodPickerKey.From]: FormControl<Date | null>;
    [MyuiPeriodPickerKey.To]: FormControl<Date | null>;
  }>;
}

export interface MyuiPeriodPickerValue {
  [MyuiPeriodPickerKey.Type]: string | null;
  [MyuiPeriodPickerKey.Option]: string | null;
  [MyuiPeriodPickerKey.Range]: MyuiEditableType<MyuiPeriodPickerRange>;
}

export interface MyuiPeriodPickerOption {
  key: string;
  label: string;
  compute: (
    o: MyuiPeriodPickerOption,
    v: MyuiPeriodPickerValue,
  ) => MyuiPeriodPickerRange | null;
}

export interface MyuiPeriodPickerContext extends MyuiTemplateContext<MyuiPeriodPickerValue> {
  label: string;
}
